import AccordionStep from '@components/common/AccordionStep';
import { ErrorFallback } from '@components/common/ErrorBoundary';
import { getStep } from '@state/features/accordion.selectors';
import { getAftercareInfo } from '@state/features/aftercare.index';
import { AftercareActionTypes } from '@state/features/common.types';
import addressutils from '@utils/addressutils';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import React, { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import AftercareConfirm from './AftercareConfirm';
import AftercareStep1 from './AftercareStep1';
import AftercareStep2 from './AftercareStep2';
import AftercareStep3 from './AftercareStep3';
import AftercareStep4 from './AftercareStep4';
import AftercareStep5 from './AftercareStep5';
import ClientServiceSection from '../clientService/ClientServiceSection';
const AftercareStepContainer = (props) => {
    const { t } = useTranslation();
    const step = useSelector(getStep);
    const { aftercareRequest } = useSelector(getAftercareInfo);
    // @ts-ignore
    const [aftercareCaseNumber, setAftercareCaseNumber] = React.useState();
    const [formdef, setFormdef] = useState();
    const [loginStep, setLoginStep] = useState();
    useEffect(() => {
        let val = {};
        api.getForm('aftercare-info', val).then((data) => {
            setFormdef(data);
        });
    }, []);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch({
            type: AftercareActionTypes.FETCH_AFTERCARE,
        });
    }, []);
    if (!aftercareRequest) {
        return React.createElement(React.Fragment, null);
    }
    if (!aftercareRequest.started) {
        return (React.createElement(ClientServiceSection, { title: t('aftercare.title'), introSection: true },
            React.createElement("div", { className: "client-service" },
                React.createElement("div", { className: "aftercare" },
                    React.createElement("div", { className: "aftercare__descriptions mb-60" },
                        React.createElement("p", { className: "aftercare__description" }, t('aftercare.description')),
                        React.createElement("p", { className: "aftercare__description", dangerouslySetInnerHTML: { __html: t('aftercare.faqlink', { link: props.faqurl }) } })),
                    React.createElement(AftercareStep1, Object.assign({}, props, { setLoginStep: setLoginStep }))))));
    }
    const onSubmit = (casenumber) => {
        setAftercareCaseNumber(casenumber);
    };
    const numOfImages = () => {
        return ((aftercareRequest.file1 ? 1 : 0) +
            (aftercareRequest.file2 ? 1 : 0) +
            (aftercareRequest.file3 ? 1 : 0) +
            (aftercareRequest.file4 ? 1 : 0) +
            (aftercareRequest.file5 ? 1 : 0) +
            (aftercareRequest.file6 ? 1 : 0));
    };
    return aftercareCaseNumber ? (React.createElement(AftercareConfirm, Object.assign({ casedate: aftercareCaseNumber.casedate, startNewAfterCare: () => setAftercareCaseNumber(null), loginStep: loginStep, aftercareCaseNumber: aftercareCaseNumber.data, formdef: formdef }, props))) : (React.createElement(ClientServiceSection, { title: t('aftercare.title'), introSection: true },
        React.createElement("div", { className: "client-service" },
            React.createElement("div", { className: "aftercare" },
                React.createElement("div", { className: "aftercare_accordion" },
                    React.createElement(AccordionStep, { id: "customer", title: t('aftercare.steps.customerinformation'), 
                        // pushAnalytics={() => {
                        //   analytics.aftercareBackEdit('customer information', 'edit');
                        // }}
                        description: step !== 'customer' &&
                            addressutils.salutation(aftercareRequest.firstname, aftercareRequest.lastname, formutils.labelByValue(aftercareRequest.title, formdef === null || formdef === void 0 ? void 0 : formdef.title)), openstep: step, editable: step !== 'customer', isDone: step === 'service' || step === 'product' || step === 'images' || step === 'review' },
                        React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                            React.createElement(AftercareStep1, Object.assign({}, props, { setLoginStep: setLoginStep })))),
                    React.createElement(AccordionStep, { id: "service", title: t('aftercare.steps.service'), 
                        // pushAnalytics={() => {
                        //   analytics.aftercareBackEdit('service required', 'edit');
                        // }}
                        description: step === 'product' || step === 'images' || step === 'review' ? (React.createElement("span", null,
                            aftercareRequest.service === 'AFTER_SALE' && t('aftercare.repair'),
                            aftercareRequest.service === 'ADVICE' && t('aftercare.advice'))) : (t('aftercare.selectservice')), openstep: step || 'service', editable: step === 'product' || step === 'images' || step === 'review', isDone: step === 'product' || step === 'images' || step === 'review' },
                        React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                            React.createElement(AftercareStep2, Object.assign({}, props)))),
                    React.createElement(AccordionStep, { id: "product", title: t('aftercare.steps.productidentification'), 
                        // pushAnalytics={() => {
                        //   analytics.aftercareBackEdit('product identification', 'edit');
                        // }}
                        description: step === 'images' || step === 'review' ? (React.createElement("span", null,
                            aftercareRequest.purchased,
                            ", ",
                            aftercareRequest.garmentName,
                            ", ",
                            aftercareRequest.productCode.toUpperCase(),
                            ", ",
                            aftercareRequest.colour,
                            ", ",
                            aftercareRequest.size)) : null, openstep: step, editable: step === 'images' || step === 'review', isDone: step === 'images' || step === 'review' },
                        React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                            React.createElement(AftercareStep3, Object.assign({}, props)))),
                    React.createElement(AccordionStep, { id: "images", title: t('aftercare.steps.images'), 
                        // pushAnalytics={() => {
                        //   analytics.aftercareBackEdit('upload all required images', 'edit');
                        // }}
                        description: step === 'review' ? React.createElement("span", null, t('aftercare.images.uploaded', { number: numOfImages() })) : null, openstep: step, editable: step === 'review', isDone: step === 'review' },
                        React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                            React.createElement(AftercareStep4, Object.assign({}, props)))),
                    React.createElement(AccordionStep, { id: "review", title: t('aftercare.steps.review'), description: step === 'review' ? (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-lg-16" }, t('aftercare.pleaseverify')))) : null, openstep: step },
                        React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                            React.createElement(AftercareStep5, Object.assign({ aftercareRequest: aftercareRequest }, props, { onSubmit: onSubmit })))))))));
};
export default AftercareStepContainer;
